import React, { Component } from 'react';
import { connect } from 'react-redux';
import { API, Auth } from 'aws-amplify';
import { Button, Form, Input, Layout, Row, Col, Spin, Select } from 'antd';
import { LeftOutlined, TableOutlined } from '@ant-design/icons';

const { Header, Content } = Layout;
const FormItem = Form.Item;
const ButtonGroup = Button.Group;
const Option = Select.Option;


function hasErrors(fieldsError) {
    return Object.keys(fieldsError).some(field => fieldsError[field]);
}


class Create extends Component {
    state = {
        loading: false,
        hotelsOptions: [],
        selectedHote: '',
        roomTypeOptions: []
    }

    idToken = '';


    loadData() {
        this.props.form.validateFields();
        this.setState({loading: true});
        this.setHotelsMenu();
        this.setState({loading: false});
    }

    setHotelsMenu() {
        const enabledHotels = this.props.hotels;
        var hotels = [];

        for (var i in enabledHotels) {
            hotels.push(<Option key={i}>{enabledHotels[i]}</Option>);
        }

        this.setState({hotelsOptions: hotels});
    }

    loadRoomTypes = (optionSelected) => {
        API.get('benackoAPI', '/room-types?hotelId=' + optionSelected, {
                headers: {
                    Authorization: this.idToken
                }
            })
            .then( response => {
                var options = [];

                response.forEach( type => {
                    options.push(<Option key={type.id}>{type.name}</Option>);
                });

                this.setState({ roomTypeOptions: options, loading: false });
            })
            .catch( errRoomTypes => {
                console.log('Error loading room types:', errRoomTypes);
                this.setState({ loading: false });
            });
    }

    componentDidMount() {
        Auth.currentSession()
            .then( response => {
                this.idToken = response.idToken.jwtToken;

                this.loadData();
            })
            .catch( error => {
                console.log(error);
            });
    }

    createRoomHandler = (event) => {
        event.preventDefault();

        this.setState({loading: true});

        this.props.form.validateFields((err, values) => {
            if (!err) {

                const beautifiedName = values.name.trim().toLowerCase();

                API.post('benackoAPI', '/rooms', {
                    body: {
                        name: beautifiedName,
                        roomTypeId: values.roomType,
                        hotelId: values.hotel
                    },
                    headers: {
                        Authorization: this.idToken
                    }
                })
                .then( () => {
                    this.setState({loading: false});
                    this.props.history.goBack();
                })
                .catch( error => {
                    console.log(error);
                    this.setState({loading: false});
                });
            }
        });
    }

    goBackHandler = () => {
        this.props.history.goBack();
    }

    render() {
        const { getFieldDecorator, getFieldsError, getFieldError, isFieldTouched } = this.props.form;

        // Only show error after a field is touched.
        const hotelError = isFieldTouched('hotel') && getFieldError('hotel');
        const roomTypeError = isFieldTouched('roomType') && getFieldError('roomType');
        const nameError = isFieldTouched('name') && getFieldError('name');

        return(
            <Layout>
                <Header style={{ background: '#fff', padding: 0 }}>
                    <Row>
                        <ButtonGroup>
                            <Button type="primary" onClick={this.goBackHandler}>
                                <LeftOutlined />Regresar
                            </Button>
                        </ButtonGroup>
                    </Row>
                </Header>
                <Content style={{ margin: 0, padding: 0, background: '#ffff' }}>
                    <Spin spinning={this.state.loading} size="large">
                        <Form onSubmit={this.createRoomHandler} className="login-form">
                            <Row style={{marginTop: 30}}>
                                <Col span={20} offset={2}>
                                    <p>Hotel:</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={20} offset={2}>
                                    <FormItem
                                        validateStatus={hotelError ? 'error' : ''}
                                        help={hotelError || ''}
                                    >
                                        {getFieldDecorator('hotel', {
                                            rules: [{ required: true, message: 'Selecciona un hotel' }]
                                        })(
                                            <Select onChange={this.loadRoomTypes}>
                                                {this.state.hotelsOptions}
                                            </Select>
                                        )}
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row style={{marginTop: 30}}>
                                <Col span={20} offset={2}>
                                    <p>Tipo de habitación:</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={20} offset={2}>
                                    <FormItem
                                        validateStatus={roomTypeError ? 'error' : ''}
                                        help={roomTypeError || ''}
                                    >
                                        {getFieldDecorator('roomType', {
                                            rules: [{ required: true, message: 'Selecciona un tipo de habitación' }]
                                        })(
                                            <Select>
                                                {this.state.roomTypeOptions}
                                            </Select>
                                        )}
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row style={{marginTop: 10}}>
                                <Col span={20} offset={2}>
                                    <p>Nombre:</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={20} offset={2}>
                                    <FormItem
                                        validateStatus={nameError ? 'error' : ''}
                                        help={nameError || ''}
                                    >
                                        {getFieldDecorator('name', {
                                            rules: [{ required: true, message: 'Introduce un nombre' }],
                                        })(
                                            <Input prefix={<TableOutlined style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Nombre" />
                                        )}
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row style={{marginTop: 10}}>
                                <Col span={4} offset={2}>
                                    <FormItem>
                                        <Button type="primary" 
                                            htmlType="submit" 
                                            disabled={hasErrors(getFieldsError())} className="login-form-button"
                                        >
                                            Crear
                                        </Button>
                                    </FormItem>
                                </Col>
                            </Row>
                        </Form>
                    </Spin>
                </Content>
            </Layout>
        );
    }
}

const mapStateToProps = state => {
    return {
        hotels: state.auth.hotels
    };
};


export default connect(mapStateToProps, null)(Create);